import ReactHtmlParser from 'react-html-parser'
import { Button } from 'components'

// css
import 'assets/style/components/alert.scss'
/**
 * @description Confirm Modal 공통 컴포넌트
 * @author 이종술
 * @since 2023-01-01
 * 업무 : 컴포넌트 > 모달 > 공통 > Confirm
 */
const ConfirmModal = (props) => {
  return (
    <>
      <section className={'alert-modal show'}>
        <div className="popup-dim" onClick={props.cancel}></div>
        <section className="alert-window">
          <p>{ReactHtmlParser(props.contents)}</p>
          <div className="btn-box">
            <Button
              text="취소"
              color="black"
              onClick={() => {
                props.cancel()
              }}
            />
            <Button text={props.okButtonName} color="primary" onClick={props.ok} />
          </div>
        </section>
      </section>
    </>
  )
}

export default ConfirmModal
